import {
    FormControl,
    FormSchema,
    FormValidationRule,
    FormValidationRuleWithState,
    IControlMutator
} from "./types";

import createSchema from "./form-schema";

const createBuilder = (schema: Partial<FormSchema>) => {
    const builder = {
        form: createSchema(schema)
    };
    return Object.assign(builder, formBuilderBehaviours(builder.form));
};

const getMaximumId = (form: FormSchema) =>
    Math.max(...form.controls.map(e => e.fieldId));

/**
 * Form builder Behaviours
 * @param self
 */

const formBuilderBehaviours = (self: FormSchema) =>
    Object.assign(
        {},
        canAddRules(self),
        canAppendControl(self),
        canPrependControl(self),
        canInsertControl(self),
        canUpdateControls(self)
    );

const canAddRules = (form: FormSchema) => ({
    addRules: (rules: (FormValidationRule | FormValidationRuleWithState)[]) => {
        form.rules = form.rules.concat(rules);
    }
});

const canAppendControl = (form: FormSchema) => ({
    appendControl: (control: FormControl) => {
        const id = control.id || getMaximumId(form) + 1;
        form.controls.push({
            ...control,
            id: `field_${control.formId}_${id}`,
            fieldId: id,
            name: `input_${id}`
        });
        return id;
    }
});

const canPrependControl = (form: FormSchema) => ({
    prependControl: (control: FormControl) => {
        const id = control.id || getMaximumId(form) + 1;
        form.controls.unshift({
            ...control,
            id: `field_${control.formId}_${id}`,
            fieldId: id,
            name: `input_${id}`
        });
        return id;
    }
});

const canInsertControl = (form: FormSchema) => ({
    insertControl: (index: number, control: FormControl) => {
        const id = control.id || getMaximumId(form) + 1;
        form.controls.splice(index, 0, {
            ...control,
            id: `field_${control.formId}_${id}`,
            fieldId: id,
            name: `input_${id}`
        });
        return id;
    }
});

const canUpdateControls = (form: FormSchema) => ({
    updateControls: (updater: IControlMutator | IControlMutator[]) => {
        const callbacks = Array.isArray(updater) ? updater : [updater];
        const update = form.controls.reduce(
            (collection: FormControl[], current: FormControl, i: number) =>
                collection.concat([
                    callbacks.reduce((control, cb) => cb(control, i), current)
                ]),
            []
        );
        form.controls = update;
    }
});

export default createBuilder;
